import { ArchiveIcon, FolderPlusIcon } from '@phosphor-icons/react';
import { useSearchParams } from 'react-router';
import { Button, EmptyState, IconButton, PageHeader, Segmented, Skeleton } from '../../ui';
import { PageBody } from '../common';
import { useHome, usePages } from './api';
import { NewPageSheet } from './NewPageSheet';
import { PageFolders } from './PageFolders';

export function SchedeListPage() {
  const [params, setParams] = useSearchParams();
  const showArchived = params.get('archiviate') === '1';
  const pages = usePages(showArchived);
  const home = useHome();
  const newOpen = params.get('nuova') === '1';

  const setNewOpen = (open: boolean) => {
    const next = new URLSearchParams(params);
    if (open) next.set('nuova', '1');
    else next.delete('nuova');
    setParams(next, { replace: true });
  };
  const setArchived = (value: 'attive' | 'archiviate') => {
    const next = new URLSearchParams(params);
    if (value === 'archiviate') next.set('archiviate', '1');
    else next.delete('archiviate');
    setParams(next, { replace: true });
  };

  const list = (pages.data ?? []).filter((p) => p.archived === showArchived);

  return (
    <PageBody className="mx-auto max-w-3xl">
      <PageHeader
        title="Schede"
        subtitle={
          pages.data ? `${list.length} ${list.length === 1 ? 'scheda' : 'schede'}` : undefined
        }
        actions={
          <>
            <IconButton
              icon={FolderPlusIcon}
              label="Nuova scheda"
              onClick={() => setNewOpen(true)}
              className="lg:hidden"
            />
            <Button
              icon={FolderPlusIcon}
              onClick={() => setNewOpen(true)}
              className="hidden lg:inline-flex"
            >
              Nuova scheda
            </Button>
          </>
        }
      />
      <Segmented
        label="Quali schede"
        value={showArchived ? 'archiviate' : 'attive'}
        onChange={setArchived}
        options={[
          { value: 'attive', label: 'Attive' },
          { value: 'archiviate', label: 'Archiviate' },
        ]}
        className="mb-6"
      />
      {pages.isLoading ? (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-28 w-full rounded-[18px]" />
          <Skeleton className="h-28 w-full rounded-[18px]" />
        </div>
      ) : list.length === 0 ? (
        showArchived ? (
          <EmptyState
            icon={ArchiveIcon}
            title="Nessuna scheda archiviata"
            message="Le schede che archivi finiscono qui e si possono ripristinare."
          />
        ) : (
          <EmptyState
            icon={FolderPlusIcon}
            title="Crea la prima scheda"
            message="Una cartellina per ogni pagina o cliente: contenuti, info, accessi e attività in un posto solo."
            action={
              <Button icon={FolderPlusIcon} onClick={() => setNewOpen(true)}>
                Nuova scheda
              </Button>
            }
          />
        )
      ) : (
        <PageFolders pages={list} badges={home.data?.badges} />
      )}
      <NewPageSheet open={newOpen} onOpenChange={setNewOpen} count={pages.data?.length ?? 0} />
    </PageBody>
  );
}
